/**
 * @description client 侧的工具函数集合
 */
import { theme as antdTheme } from 'antd'
import type { ThemeType } from '@shared/common-types.js'
import { PIE_CHART_DATA_LIMIT } from '../shared/constants.js'

/**
 *  PieChart => sort by second property & slice 15 items
 */
export function sortBySecondProperty(array: Array<{ [key: string]: any }>): Array<{ [key: string]: any }> {
  if (array.length < 1 || array[0] === undefined) {
    console.error('sortBySecondProperty: array is empty')
    return [] // 返回空数组而不是抛出错误
  }
  if (array.length < 2 || Object.keys(array[0]).length < 2) {
    return array
  }
  const sortedArray = [...array]
  sortedArray.sort(function (a, b) {
    const secondProperty = Object.keys(a)[1] ?? ''
    const valueA = Number(a[secondProperty])
    const valueB = Number(b[secondProperty])
    if (isNaN(valueA) || isNaN(valueB)) {
      return String(a[secondProperty]).localeCompare(String(b[secondProperty]))
    }
    return valueB - valueA
  })

  const mergedData = sortedArray.slice(0, PIE_CHART_DATA_LIMIT - 1)
  const others = sortedArray.slice(PIE_CHART_DATA_LIMIT - 1)
  if (others.length > 0) {
    const totalSalesSum = others.reduce((sum, item) => {
      const totalSales = Number(item[Object.keys(array[0]!)[1]!])
      return sum + (isNaN(totalSales) ? 0 : totalSales)
    }, 0)
    const othersObject: { [key: string]: any } = {}
    othersObject[Object.keys(array[0])[0]!] = '其他'
    othersObject[Object.keys(array[0])[1]!] = totalSalesSum.toString()

    mergedData.push(othersObject)
  }
  return mergedData
}

const antdDeignToken = {
  components: {
    Table: {
      cellPaddingInlineSM: 6,
      cellPaddingBlockSM: 5,
    },
    Button: {
      borderRadius: 6,
      controlHeight: 32,
      controlHeightLG: 40,
      controlHeightSM: 24,
      paddingInline: 16,
      paddingInlineLG: 24,
      paddingInlineSM: 8,
      colorPrimary: '#1890ff',
      colorPrimaryHover: '#40a9ff',
      colorPrimaryActive: '#096dd9',
    },
    Tooltip: {
      colorBgSpotlight: 'rgba(0, 0, 0, 0.85)',
      colorTextLightSolid: '#fff',
    },
  },
}

/** 返回 Antd ConfigProvider theme 中的配置 */
export function getAntdConfigProviderTheme(theme: ThemeType) {
  const config =
    theme === 'dark'
      ? {
          algorithm: antdTheme.darkAlgorithm,
          token: {
            colorBgBase: 'rgb(51 65 85 1)',
            colorTextBase: '#fff',
          },
          components: {
            ...antdDeignToken.components,
            Tooltip: {
              colorBgSpotlight: 'rgba(0, 0, 0, 0.85)',
              colorTextLightSolid: '#fff',
            },
          },
        }
      : {
          algorithm: antdTheme.defaultAlgorithm,
          ...antdDeignToken,
        }

  return config
}
